module.exports = __webpack_public_path__ + "img/IMG_9519_L_BlackMatted_MockedUp.e560a17b.jpg";